import * as React from 'react';
import { Themeable } from './types';
import { ThemeContext } from './context';
import { getTheme } from './utils';

/**
 * A hook to use the closest theme context.
 *
 * @param props - Current component props
 * @param styles - The css modules styles for the component
 *
 * @example
 * const { themeClass } = useTheme({ colorScheme, theme }, styles);
 */
export const useTheme = (
  props: Themeable,
  styles: Record<string, string> = {}
) => getTheme(props, React.useContext(ThemeContext), styles);
